module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/261-kiribati-de9bf575251262d6b097a1177f99b5a9.svg";